// 体育游State Module
import {
  FETCH_SPORTS_TOUR_FILTER_INFO,
  FETCH_SPORTS_TOUR_ROUTE_LIST,
  FETCH_SPORTS_TOUR_ROUTE_BY_ID,
} from '../mutation-types'

const initialState = {
  sportsTourRoute: {},     // 某条线路
  categories: [],         // 频道栏
  routes: [],             // 线路
  filterInfo: {},         // 筛选信息
}

const initialMutations = {
  [FETCH_SPORTS_TOUR_ROUTE_LIST](state, data) {
    state.routes = data.routes
  },
  [FETCH_SPORTS_TOUR_FILTER_INFO](state, data) {
    state.filterInfo.categories = data.categories
    state.filterInfo.citys = data.cities
    state.filterInfo.labels = data.labels
  },
  [FETCH_SPORTS_TOUR_ROUTE_BY_ID](state, data) {
    state.sportsTourRoute = data
  },
}

export default {
  state: initialState,
  mutations: initialMutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/sportsTour.js